export const SIDE_NAVIGATION_PARENT_NEW_BADGE_TEST_ID = 'side-nav-parent-new-badge';
export const SIDE_NAVIGATION_CHILD_NEW_BADGE_TEST_ID = 'side-nav-child-new-badge';
export const SIDE_NAVIGATION_ITEM_TEST_ID = 'side-navigation-item-test-id';
export const SIDE_NAVIGATION_ACTIVE_ITEM_TEST_ID = 'side-navigation-active-item-test-id';
export const SIDE_NAVIGATION_PARENT_BADGE_TEST_ID = 'side-nav-parent-badge';
export const SIDE_NAVIGATION_CHILD_BADGE_TEST_ID = 'side-nav-child-badge';
